import React from "react";
import ReactDOM from "react-dom";
import firebase from "firebase";
import Modal from "react-modal";
import DebounceInput from "react-debounce-input";

import EditInfo from "./EditInfo";
import AddInfo from "./AddInfo";
import Spinner from "react-spinkit";
import Nav from "../../components/Nav/Nav";
import { STATUS } from "../../constants/constants";
import { StyleSheet, css } from "aphrodite";

import { connect } from "react-redux";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
const firstRow = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1'];

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "640px",
    height: "90%"
  }
};

class UserManagement extends React.Component {
  constructor(props) {
    super(props);
    if (firebase.apps.length === 0) {
      const config = {
        apiKey: "AIzaSyCe_Xt__m4WQKhBd6sKizvh3imEQReXA0g",
        authDomain: "picnowtest.firebaseapp.com",
        databaseURL: "https://picnowtest.firebaseio.com",
        storageBucket: "picnowtest.appspot.com",
        messagingSenderId: "323233553771"
      };
      firebase.initializeApp(config);
    }
  }

  state = {
    list: null,
    listLength: 0,
    data: null,
    loading: true,
    percents: 0,
    modalIsEditOpen: false,
    modalIsAddOpen: false,
    modalUserInfo: {},
    pageCount: 1,
    offset: 21,
    nextKey: null,
    prevKeys: [],
    submitCheck: true,
    isNextPage: false,
    query: ""
  };

  componentDidMount() {
    this.counting = ReactDOM.findDOMNode(this.refs.counting);
    this.getData();
  }

  getData = async () => {
    this.faculties = await this.getFaculty();
    this.loadData();
  }

  //Clear
  loadData = async (key, query) => {
    const { offset } = this.state;
    const { universityFirebase } = this.props;
    this.setState({ loading: true });

    let ref = firebase
      .database()
      .ref(`${universityFirebase}/users/`)
      .orderByKey();

    if (query) {
      ref = ref.equalTo(query.toString());
    }

    if (key) {
      ref = ref.startAt(key);
    }
    return ref
      .limitToFirst(offset)
      .once("value")
      .then(async snapshot => {
        try {
          const value = snapshot.val();

          if (value) {
            const keys = Object.keys(value);
            let nextKey, data;

            data = await Promise.all(
              Object.values(value).map(async (e) => {
                const snap = await firebase
                  .database()
                  .ref(`${universityFirebase}/rawDataById/${e.studentId}`)
                  .once("value");
                const rdata = snap.val();

                e.status = (rdata && rdata.status) || 'new';
                return e;
              })
            );

            if (keys.length < offset) {
              nextKey = "__lastPage__";
            } else {
              nextKey = keys.splice(keys.length - 1, 1)[0];
              delete data[nextKey];
            }

            if (query) {
              this.setState({
                loading: false,
                data,
                nextKey: null,
                prevKeys: []
              });
            } else {
              this.setState({ loading: false, data, nextKey });
            }

          } else {
            this.setState({ loading: false });
          }

        } catch (error) {
          console.log("Error :", error);
        }
        this.setState({ isNextPage: false });
      });
  };

  getFaculty = async () => {
    const { universityFirebase } = this.props;

    const snap = await firebase
      .database()
      .ref(`${universityFirebase}/faculties`)
      .once("value");
    return snap.val();
  }

  //Clear
  handleNext = () => {
    const { prevKeys, data, nextKey } = this.state;
    const tmpPrevKeys = prevKeys.map(prevKey => prevKey);
    const firstKey = Object.keys(data)[0];
    tmpPrevKeys.push(data[firstKey].studentCode);
    this.setState({ prevKeys: tmpPrevKeys, isNextPage: true }, () => {
      this.loadData(nextKey);
    });
  };

  //Clear
  handlePrev = () => {
    const { prevKeys } = this.state;
    const tmpPrevKeys = prevKeys.map(prevKey => prevKey);
    const lastPrevKey = tmpPrevKeys.splice(tmpPrevKeys.length - 1, 1);
    this.setState({ prevKeys: tmpPrevKeys, isNextPage: true }, () => {
      this.loadData(lastPrevKey.toString());
    });
  };

  checkingValidOfFile(columns) {
    const keys = [
      "STUDENTCODE", //
      "PREFIXNAME", //
      "CAMPUSID", //
      "STUDENTNAME", //
      "STUDENTSURNAME", //
      "CITIZENID4", //
      "FACULTYID", //
      "DRESSCODE", //
      "LEVELID", //
      "SEX", //
      "ACADYEAR" //
    ];
    const arrLength = keys.length;
    for (let i = 0; i < arrLength; i++) {
      if (!columns.includes(keys[i])) {
        return { result: false, missingField: keys[i] };
      }
    }
    return { result: true };
  }

  getAllUserKeys = async () => {
    const { universityFirebase } = this.props;
    try {

      let users = await firebase
        .database()
        .ref(`${universityFirebase}/users`)
        .once("value");
      users = users.val()
      return Object.keys(users);
    } catch (error) {
      console.log('Error', 'getAllUsers', error)
    }

  };

  handleChange = e => {
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onload = async event => {

      let data = event.target.result;
      let workbook = XLSX.read(data, { type: "binary" });

      if (workbook.SheetNames[0]) {

        const sheetName = workbook.SheetNames[0];
        const workSheet = workbook.Sheets[sheetName];
        const userKeysOnDatabase = await this.getAllUserKeys();

        const result = XLSX.utils.sheet_to_json(workSheet).filter(item => !userKeysOnDatabase.includes(item.STUDENTCODE));

        if (result.length === 0) {
          return this.setState({ list: [], listLength: 0, submitCheck: false });
        }

        const columns = [];
        for (let z in workSheet) {
          if (firstRow.includes(z.toString())) {
            columns.push(workSheet[z].v);
          }
        }

        const fileResult = this.checkingValidOfFile(columns);
        if (fileResult.result) {
          this.setState({ list: result, listLength: result.length, submitCheck: false });
        } else {
          this.setState({ submitCheck: true });
          alert(`Missing field: ${fileResult.missingField}`);
        }


      } else {
        this.setState({ submitCheck: true });
        alert("You input the wrong template");
      }
    };
    reader.readAsBinaryString(file);
  };

  //Clear
  handleSubmit = () => {
    const { list } = this.state;
    const { universityFirebase } = this.props;

    this.setState({ loading: true, isOnUploading: true }, () => {
      // firebase
      //   .database()
      //   .ref(`${universityFirebase}/users`)
      //   .set({});

      const promises = list.map(item => {
        return firebase
          .database()
          .ref(`${universityFirebase}/users/${item.STUDENTCODE}`)
          .update({
            studentId: item.STUDENTCODE || 0,
            prefixName: item.PREFIXNAME || "",
            campusId: item.CAMPUSID || "",
            studentName: item.STUDENTNAME || "",
            studentSurname: item.STUDENTSURNAME || "",
            citizenId: item.CITIZENID4 || "",
            facultyId: Number.parseInt(item.FACULTYID, 10) || 999,
            levelId: item.LEVELID || "",
            email: item.EMAIL || "",
            phone: item.PHONE || "",
            sex: item.SEX || "",
            year: item.ACADYEAR || "",
            dressCode: item.DRESSCODE,
            isApproved: item.isApproved ? item.isApproved.toLowerCase() === "true" : false
          });
      });

      Promise.all(promises)
        .then(() => {
          this.setState({ loading: false }, () => {
            this.loadData();
          });
        })
        .catch(err => {
          alert("Import Error", err);
          this.setState({ loading: false });
        });
    });
    this.setState({ isOnUploading: false });
  };

  handleQueryChange = event => {
    this.setState({ query: event.target.value });
    this.loadData(null, event.target.value);
  };

  //Clear
  handleRemove = async data => {
    const { universityFirebase } = this.props;
    let confirm = window.confirm("Delete this user?");
    if (confirm) {
      const name = data.studentId;
      this.setState({ isNextPage: true }, async () => {
        try {
          await firebase
            .database()
            .ref(`${universityFirebase}/users/${name}`)
            .remove();
        } catch (e) {
          console.log("error", e);
        }
        this.loadData();
      });
    }
  };

  //Clear
  handleEdit = data => {
    const modalUserInfo = data;
    this.setState({ modalUserInfo: modalUserInfo, modalIsEditOpen: true });
  };

  s2ab(s) {
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

  matchKeyNameWithImportExcel = key => {
    if (key.toLowerCase() === "studentid") key = "STUDENTCODE";
    else if (key.toLowerCase() === "citizenid") key = "CITIZENID4";
    else if (key.toLowerCase() === "year") key = "ACADYEAR";
    return key.toString().toUpperCase();
  };

  handleAllRemove = () => {
    const { universityFirebase } = this.props;
    if (window.confirm("Do you want to remove all users?")) {
      this.setState({ loading: true }, async () => {
        await firebase
          .database()
          .ref(`${universityFirebase}/users`)
          .remove();
        this.setState({ loading: false, data: null });
      });
    }
  };

  handleExport = () => {
    const { universityFirebase } = this.props;
    this.setState({ loading: true }, async () => {
      const users = await firebase
        .database()
        .ref(`${universityFirebase}/users`)
        .once("value");

      //Make Key Uppercase
      let data = Object.values(users.val()).map(value => {
        let keys = Object.keys(value);
        let length = keys.length;
        let result = {};
        for (let i = 0; i < length; i++) {
          const key = keys[i];
          const sheetColumn = this.matchKeyNameWithImportExcel(key);
          result[sheetColumn] = value[key];
        }
        return result;
      });

      const mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";

      const workbook = { SheetNames: [], Sheets: {} };
      const worksheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Student");
      const wopts = { bookType: "xlsx", bookSST: false, type: "binary" };
      const newWorkbook = XLSX.write(workbook, wopts);
      const blob = new Blob([this.s2ab(newWorkbook)], { type: mimeType });

      FileSaver.saveAs(blob, "Student.xlsx");
      this.setState({ loading: false });
    });
  };

  convertStatus = status => {
    let result = {};
    switch (status) {
      case STATUS.NONE:
        result.status = "New";
        result.class = 'text-success';
        break;
      case STATUS.APPROVED:
        result.status = "Approved";
        result.class = 'text-info';
        break;
      case STATUS.REJECTED:
        result.status = "Rejected";
        result.class = 'text-danger';
        break;
      case STATUS.DOWNLOADED:
        result.status = "Downloaded";
        result.class = 'text-primary';
        break;
      default:
        result.status = "New";
        result.class = 'text-success';
        break;
    }
    return result;
  };

  //Clear
  getUsers = () => {
    if (!this.state.loading) {
      if (this.state.data) {
        let convert = {};

        return this.state.data.map((data, i) => {
          convert = this.convertStatus(data.status);

          return (
            <tr key={i}>
              <td>
                <b>{data.studentId}</b>
              </td>
              <td>{data.prefixName}</td>
              <td>{data.studentName}</td>
              <td>{data.studentSurname}</td>
              <td>{data.citizenId}</td>
              <td>{data.email || "-"}</td>
              <td>{data.phone || "-"}</td>
              <td>{data.sex === "M" ? "Male" : "Female"}</td>
              <td>{data.year || "-"}</td>
              <td>{this.faculties[data.facultyId]}</td>
              <td>{data.dressCode}</td>
              <td>{data.isApproved ? "Yes" : "No"}</td>
              <td className={convert.class}>{convert.status}</td>
              <td>
                <button className="btn btn-sm btn-success" onClick={event => this.handleEdit(data)}>
                  Edit
                </button>
              </td>
              <td>
                <button className="btn btn-sm btn-danger" onClick={event => this.handleRemove(data)}>
                  Remove
                </button>
              </td>
            </tr>
          );
        });
      } else {
        return (
          <tr className={"text-center"}>
            <td colSpan="15">ไม่พบข้อมูล</td>
          </tr>
        );
      }
    } else {
      return (
        <tr className={"text-center"}>
          <td colSpan="15">
            <Spinner name="three-bounce" color={"#0070bf"} className={`${css(styles.loadingAtDownload)}`} /> Loading...
          </td>
        </tr>
      );
    }
  };

  //Clear
  renderModal = () => {
    const { modalIsAddOpen, modalIsEditOpen, modalUserInfo } = this.state;
    const { universityFirebase } = this.props;
    return (
      <div>
        <Modal contentLabel="Modal" isOpen={modalIsEditOpen} style={modalStyles}>
          <EditInfo
            universityFirebase={universityFirebase}
            modalUserInfo={modalUserInfo}
            updateTable={this.loadData}
            closeModal={() => {
              this.setState({ modalIsEditOpen: false });
            }}
          />
        </Modal>
        <Modal contentLabel="Modal" isOpen={modalIsAddOpen} style={modalStyles}>
          <AddInfo
            universityFirebase={universityFirebase}
            updateTable={this.loadData}
            closeModal={isEdit => {
              this.setState({ modalIsAddOpen: false });
              if (isEdit) {
                this.loadData();
              }
            }}
          />
        </Modal>
      </div>
    );
  };

  //Clear
  render() {
    const { prevKeys, nextKey, query, isOnUploading, submitCheck, isNextPage } = this.state;
    return (
      <div>
        {this.renderModal()}
        <Nav />
        <br />
        <div className={"row"}>
          <div className={"col-md-6"}>
            <h3>Upload new file to replace the last one.</h3>
            <p className="lead">Supported formats:</p>
            <ul>
              <li>Excel 2007+ XML Formats (XLSX/XLSM)</li>
              <li>Excel 2007+ Binary Format (XLSB BIFF12)</li>
              <li>Excel 2003-2004 XML Format (XML "SpreadsheetML")</li>
              <li>Excel 97-2004 (XLS BIFF8)</li>
              <li>Excel 5.0/95 (XLS BIFF5)</li>
              <li>Excel 2.0/3.0/4.0 (XLS BIFF2/BIFF3/BIFF4)</li>
              <li>OpenDocument Spreadsheet (ODS)</li>
            </ul>
          </div>
          <div className={"col-md-6"}>
            <h3>Upload file</h3>

            <p className="lead">Header in excel:</p>
            <ul>
              <li>STUDENTCODE</li>
              <li>PREFIXNAME</li>
              <li>CAMPUSID</li>
              <li>STUDENTNAME</li>
              <li>STUDENTSURNAME</li>
              <li>CITIZENID4</li>
              <li>FACULTYID</li>
              <li>DRESSCODE</li>
              <li>LEVELID</li>
              <li>SEX</li>
              <li>ACADYEAR</li>
            </ul>
            <div className={"row"}>
              <div className={"col-md-4"} style={{ paddingTop: 16 }}>
                <input type="file" name="file" ref={elem => (this.file = elem)} onChange={this.handleChange} />
              </div>
              <div className={"col-md-4 text-left"}>
                <p ref="counting" />
                <input disabled={submitCheck} className="btn btn-warning" type="submit" value="Submit" onClick={this.handleSubmit} />
              </div>
            </div>
            {isOnUploading && <Spinner name="three-bounce" color="blue" className={`${css(styles.loadingOnSubmit)}`} />}
          </div>
          <div className={"row"}>
            <div className={"col-md-8"}>
              <h3>
                <span>Accessible users </span>
                <button className="btn btn-primary" onClick={() => this.setState({ modalIsAddOpen: true })}>
                  Add Student
                </button>
                <span> </span>
                <button className="btn btn-info" onClick={() => this.handleExport()}>
                  Export
                </button>
              </h3>
            </div>
            <div className={"col-md-4 text-right"}>
              <h3>
                <button className="btn btn-danger" onClick={() => this.handleAllRemove()}>
                  All Delete
                </button>
              </h3>
            </div>
          </div>
          <div className={"row"}>
            <div className={"col-md-1"}>
              <div className={"h4"}>
                <b>Search:</b>
              </div>
            </div>
            <div className={"col-md-3"}>
              <DebounceInput className={"form-control"} debounceTimeout={1000} onChange={this.handleQueryChange} value={query} />
            </div>
            <div className={"col-md-2"} />
          </div>
          <br />
          <div className={"row"}>
            <div className={"col-md-12"}>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <button className={"btn btn-success"} onClick={() => this.handlePrev()} disabled={prevKeys.length <= 0}>
                    {"<= Prev"}
                  </button>
                </div>
                <div className={"col-md-6 text-right"}>
                  <button className={"btn btn-success"} onClick={() => this.handleNext()} disabled={!nextKey || nextKey === "__lastPage__"}>
                    {"Next =>"}
                  </button>
                </div>
              </div>
              <br />
              <div className={"row"}>
                <div className={"col-md-12"}>
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Student Code</th>
                        <th>Prefix</th>
                        <th>First name</th>
                        <th>Surname</th>
                        <th>Citizen ID</th>
                        <th>E-mail</th>
                        <th>Phone</th>
                        <th>Sex</th>
                        <th>Year</th>
                        <th>Faculty</th>
                        <th>Dress Code</th>
                        <th>Approved?</th>
                        <th>Status</th>
                        <th colSpan="2" />
                      </tr>
                    </thead>
                    {isNextPage ? (
                      <tr className={"text-center"}>
                        <td colSpan="15">
                          <Spinner name="three-bounce" color={"#0070bf"} className={`${css(styles.loadingAtDownload)}`} /> Loading...
                        </td>
                      </tr>
                    ) : (
                        <tbody>{this.getUsers()}</tbody>
                      )}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    fontSize: 28,
    lineHeight: "1.2",
    margin: "0 0 1.5rem"
  },
  lead: {
    fontSize: 18,
    lineHeight: "1.5",
    margin: "0 0 1.5rem",
    color: "#555"
  },
  body: {
    fontSize: "1rem",
    lineHeight: "1.5",
    margin: "0 0 1.5rem",
    color: "#555"
  },
  list: {
    fontSize: "1rem",
    listStyle: "none",
    padding: 0
  },
  link: {
    display: "block",
    fontSize: "1.25rem",
    margin: "0 0 .5rem",
    lineHeight: "1.5",
    fontWeight: "bold",
    color: "#08c",
    opacity: 1,
    transition: ".2s opacity ease",
    textDecoration: "none",
    ":hover": {
      opacity: 0.5,
      textDecoration: "none"
    }
  },
  loadingAtDownload: {
    marginBottom: "3%",
    marginTop: "2%"
  },
  loadingOnSubmit: {
    paddingTop: "3%"
  }
});

const mapStateToProps = state => {
  return { universityFirebase: state.auth.universityFirebase };
};

export default connect(mapStateToProps)(UserManagement);



// WEBPACK FOOTER //
// /src/containers/UserManagement/UserManagement.js